import React, { Fragment, useContext } from "react";
import SharedDataContext from "../../_helper/SharedData";

const ApiLoader = () => {
  const { showApiLoader } = useContext(SharedDataContext);

  return (
    <Fragment>
      <div className={`api-loader-wrapper ${!showApiLoader ? "loderhide" : ""}`}>
        <div className="api-loader" />
      </div>
    </Fragment>
  );
};

export default ApiLoader;
